/* this file added by Bearer Web Developer  */
import React from 'react';
import styles from './time.module.scss';
import { useAppState } from '../../../../states/app-state';
import { useThemeMode } from '../../../../states/contexts/theme';

const Time: React.FC = () => {
    const appState = useAppState();
    const activeManageOrder = appState?.ReservedOrders?.activeManageOrder;
    const miliseconds = Number(activeManageOrder?.transport_creation_time);
    const date = new Date(miliseconds)?.toLocaleDateString();
    const time = new Date(miliseconds)?.toLocaleTimeString();
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles.time} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <div className={styles.date}>
                {
                    theme === 'dark' ? <img src="/calendar-month-white.svg" alt="" width={20} height={20} /> :
                        <img src="/calendar-month-grey.webp" alt="" width={20} height={20} />
                }
                <span>{date}</span>
            </div>
            <div className={styles.time_value}>
                {
                    theme === 'dark' ? <img src="/schedule-white.svg" alt="" width={20} height={20} /> :
                        <img src="/schedule-grey.webp" alt="" width={20} height={20} />
                }
                <span>{time}</span>
            </div>
        </div>
    )
}

export default Time;